enum Codes {
    DeliveryByHandCode = 39,
    DeliveryByCargoCode = 40,
    KvkkJobApplication = 90,
    KvkkRegistration = 91,
}

export default Codes;